import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogComponent } from '../components/dialog-box/mat-dialog/mat-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { LoaderService } from './loader.service';
import { CalculatorLoaderService } from './calculator-loader.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private isCompletedMain = new BehaviorSubject<any>({ isCompleted: false, index: -1 });
  isCompleted = this.isCompletedMain.asObservable();
  constructor(
    private dialog: MatDialog,
    private translate: TranslateService,
    private loader: LoaderService,
    private calLoader : CalculatorLoaderService
  ) { }

  apiErrorMessageDialog(trnID: any, errorCode: string) {
    let errorMessage = this.translate.instant(errorCode);
    const dialogRef = this.dialog.open(MatDialogComponent, {
      panelClass: ['dialog-responsive'],
      disableClose: true,
      data: { error: true, trnID, errorMessage }
    });
    dialogRef.afterClosed().subscribe();
  }

  handleStatusError(error: any): void {
    this.loader.hide();
    this.calLoader.hide();
    if (error && error.error &&
      error.error.rcode !== 401 &&
      error.error.rcode !== 403 &&
      error.error.rcode !== 404 &&
      error.error.rcode !== 500
    ) {
      const errorCode = error.error.rmsg ? error.error.rmsg[0] ? error.error?.rmsg[0]?.errorCode : 'ERROR' : 'Cors';
      let errorMessage = this.translate.instant(errorCode);

      console.error('Error Receiving data:', error);
      if (errorMessage == errorCode) {
        errorMessage = this.translate.instant('customErrMsg');
      }
      if(errorMessage == 'Cors'){
        errorMessage = this.translate.instant('corsMessage');
      }
      const _dialogRef = this.dialog.open(MatDialogComponent, {
        width: '50VW',
        disableClose: true,
        data: {
          panelClass: ['dialog-responsive'],
          disableClose: true,
          error: true, trnID: error.error.transactionRef, errorMessage
        },
      });

      _dialogRef.afterClosed().subscribe();
    }
  }
  handleRcodeError(data: any): void {
    this.loader.hide();
    this.calLoader.hide();
    const errorCode = data.rmsg[0]?.errorCode ?? 'ERROR';
    let errorMessage = this.translate.instant(errorCode);

    console.error('Error Receiving data:', data);
    if (errorMessage == errorCode) {
      errorMessage = this.translate.instant('customErrMsg');
    }
  
    const dialogRef = this.dialog.open(MatDialogComponent, {
      panelClass: ['dialog-responsive'],
      disableClose: true,
      data: {
        error: true,
        trnID: data.transactionRef,
        errorMessage,
      },
    });

    dialogRef.afterClosed().subscribe();
  }
  checkStatusErrors(error: any) {
    this.loader.hide();
    this.calLoader.hide();
    if (error && error.error &&
      error.error.rcode !== 401 &&
      error.error.rcode !== 403 &&
      error.error.rcode !== 404 &&
      error.error.rcode !== 500
    ) {
      this.handleStatusError(error);
    }

  }

}

